import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const DatoPresupuestoNivel1FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [datosPresupuestosOptions, setDatosPresupuestosOptions] = React.useState([])

  const refrescarSelect = React.useCallback(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.DATOPRESUPUESTO_NIVEL1).then(({ data }) => {
      if (data && data.length > 0) {
        setDatosPresupuestosOptions(
          data.map((x, k) => (
            <option key={k} value={x._id}>
              {x.nombre}
            </option>
          ))
        )
      }
    })
  }, [])

  React.useEffect(() => {
    refrescarSelect()
  }, [refrescarSelect])

  return (
    <>
      <Form.Group>
        <Form.Label text='NIVEL 1' htmlFor='select-datoPresupuestoNivel1' md={12} />
        <Col md={12}>
          <Field name='datoPresupuestoNivel1'>
            {({ field }) => (
              <Form.Select
                {...field}
                id='select-datoPresupuestoNivel1'
                isInvalid={iTouched && iError}
                disabled={fIsSubmitting}
              >
                <option value=''>Todos</option>
                {datosPresupuestosOptions}
              </Form.Select>
            )}
          </Field>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(DatoPresupuestoNivel1FormGroup)
